// Cross-page "part clipboard" — lets a user copy an NPD part / assembly on one page and
// paste it into any project on another page. Backed by localStorage so it survives
// navigation and reloads. Holds a single copied item.
const KEY = "aampl_part_clipboard";

export function copyPart(kind, id, label) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ kind, id, label: label || "", ts: Date.now() }));
  } catch {
    /* storage disabled — copy is a no-op */
  }
}

export function getClipboardPart() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "null");
  } catch {
    return null;
  }
}

export function clearClipboardPart() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
